import * as mutations from './mutations'

export default {
  namespaced: true,
  list: [],
  mutations
}
